import { IconCompetitor12, Label } from '@cian/ui-kit';
import * as React from 'react';

export const MediumCompetitionLevel = () => (
  <Label icon={<IconCompetitor12 color="warning_100" />} color="warning_100" background="#FFF2E6">
    Средняя
  </Label>
);
